import {
  dashboardDateQuery,
  parseDashboardDateSelection,
  type DashboardDateQuery,
  type DashboardDateSelection,
} from "@nova-ai/shared"
import { z } from "zod"

/** Canonical date search shared by both dashboard routes. Mixed, partial, and
 * unavailable forms fail route validation instead of being normalized. */
export const dashboardDateSearchSchema = z
  .object({
    period: z.string().optional(),
    month: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
  })
  .transform((query, context): DashboardDateQuery => {
    const parsed = parseDashboardDateSelection({
      ...(query.period !== undefined ? { period: query.period } : {}),
      ...(query.month !== undefined ? { month: query.month } : {}),
      ...(query.from !== undefined ? { from: query.from } : {}),
      ...(query.to !== undefined ? { to: query.to } : {}),
    })
    if (!parsed.ok) {
      context.addIssue({ code: "custom", message: parsed.error })
      return z.NEVER
    }
    return dashboardDateQuery(parsed.value)
  })

export function selectionFromDashboardSearch(search: DashboardDateQuery): DashboardDateSelection {
  const parsed = parseDashboardDateSelection(search)
  if (!parsed.ok) {
    throw new Error(parsed.error)
  }
  return parsed.value
}
